import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import SuperbetLobbyConponent from "../Components/SuperbetLobbyComponent";

interface SIL {
    atagParams: string | null,
    mode?: string | null
}
const SuperbetLobby: FC <SIL> = ({atagParams, mode}) => {
    const {getSuperbetsData} = useAction();
    const {superbetsData} = useTypedSelector((state) => state.superbetsReducer);

    useEffect(()=>{
        getSuperbetsData();
    }, [])
    return (
        <>
            {
                superbetsData.length > 0 ?
                    <SuperbetLobbyConponent data={superbetsData} atagParams={atagParams} mode={mode} />
                    : null
            }
        </>
    );

}

export default SuperbetLobby;
